import styled, {css} from 'styled-components'

export const StyledPlansListHeader = styled.div`
    ${({theme: {typography, palette}}) => css`
        display: flex;
        width: 100%;
        justify-content: space-around;
        align-items: center;
        & span {
            ${typography.textMd}
            color:${palette.primary[450]};
            text-align: center;
            font-weight: 700;
            line-height: 24px;
        }
    `}
`
export const StyledPlansList = styled.div`
    ${({theme: {scrollbar, spacing}}) => css`
        ${scrollbar}
        display: flex;
        flex-direction: column;
        align-items: center;
        align-self: stretch;
        padding-bottom: ${spacing}px;
        flex: 1;
        overflow: auto;
        padding: ${spacing * 1.25}px ${spacing / 2}px 0px ${spacing / 2}px;
        gap: ${spacing * 2}px;
    `}
`
